import React from "react"
import Cabecalho from "../Cabecalho"
import { CuponsFiscaisTabela } from "./components/CuponsFiscaisTabela"

export function EmissaoCupomFiscal() {
    return (
        <>
            <Cabecalho pagina="Solicitações de Nota Fiscal do Consumidor (NFC-e)" />
            <CuponsFiscaisTabela />
        </>
    )
}
